import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CurrentUser, Session, TrustedDevice } from '../models/account.models';

@Injectable({
  providedIn: 'root',
})
export class AccountEndpoint {
  private readonly http = inject(HttpClient);

  private readonly endpoints = {
    logoutAll: `sessions/logout-all`,
    onboarding: `me/onboarding/complete`,
    trustedDevices: `trusted-devices`,
    sessions: `sessions`,
    me: `me`,
    trustedDeviceById: (id: number) => `trusted-devices/${id}`,
    sessionById: (id: number) => `sessions/${id}`,
  };

  logoutAll() {
    return this.http.post<void>(this.endpoints.logoutAll, {});
  }

  onboardTour() {
    return this.http.post<void>(this.endpoints.onboarding, {});
  }

  // Portal: the user's remembered (trusted) devices (current one flagged)
  // withCredentials so the `portal_device` cookie is sent to flag the current device.
  getTrustedDevices() {
    return this.http.get<TrustedDevice[]>(this.endpoints.trustedDevices, { withCredentials: true });
  }

  getSessions() {
    return this.http.get<Session[]>(this.endpoints.sessions);
  }

  getMe() {
    return this.http.get<CurrentUser>(this.endpoints.me);
  }

  revokeTrustedDevice(id: number) {
    return this.http.delete<void>(this.endpoints.trustedDeviceById(id));
  }

  revokeSession(id: number) {
    return this.http.delete<void>(this.endpoints.sessionById(id));
  }
}
